import modelBaseV2 from "../model-base-v2.model";

/**
 * Purchase Order Proposal Model
 * 
 * Contains all the requests used by Purchase Order Proposal
 * 
 * @author Darrus Goh
 */
const PurchaseOrderProposalModel = {

  getPurchaseOrders: (body) => {
    return modelBaseV2.post('/api/poproposal/list', { body });
  },

  purchaseOrdersAction: (body) => {
    return modelBaseV2.post('/api/poproposal/approval', { body });
  },

  downloadPurchaseOrders: (body) => {
    const filename = `PurchaseOrder_${body.week}_ALL`;
    return modelBaseV2.postDownload('/api/poproposal/list/export', { body }, filename);
  },

  downloadPurchaseOrdersExcelFormat: (body) => {
    const filename = `PurchaseOrder_${body.week}_PENDING`;
    return modelBaseV2.postDownload('/api/poproposal/approval/download', { body }, filename);
  },

  uploadExcel: (file) => {
    let body = new FormData();
    body.append('uploadedExcel', file);

    const indexOfExtension = file.name.lastIndexOf('.'); 
    let filename = file.name;
    filename = filename.substring(0, indexOfExtension) + "_RESULTS" + filename.substring(indexOfExtension);
    
    return modelBaseV2.postDownload('/api/poproposal/approval/upload', { body }, filename);
  }

}

export default PurchaseOrderProposalModel;